// import `.less` files
import "../css/styles.less";

// import classes
import SearchAsYouType from "./SearchAsYouType";

// export
export default SearchAsYouType;